import { Controller } from "@hotwired/stimulus"

// Client-side filter for the "Use Report Template" drawer. Filters the already
// rendered report rows by name/description as the user types, and hides any
// data-source group left with no matches. Shows an empty-state when nothing
// matches.
export default class extends Controller {
  static targets = ["input", "item", "group", "empty"]

  connect() {
    this.filter()
  }

  filter() {
    const query = this.hasInputTarget
      ? this.inputTarget.value.trim().toLowerCase()
      : ""
    let anyVisible = false

    this.itemTargets.forEach((item) => {
      const haystack = item.dataset.searchName || ""
      const match = query === "" || haystack.includes(query)
      item.classList.toggle("hidden", !match)
      if (match) anyVisible = true
    })

    // Hide group headers whose reports are all filtered out.
    this.groupTargets.forEach((group) => {
      const hasVisible = group.querySelectorAll(
        '[data-report-search-target="item"]:not(.hidden)',
      ).length > 0
      group.classList.toggle("hidden", !hasVisible)
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", anyVisible)
    }
  }
}
